import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container, Card, CardBody, CardTitle, CardText, Button, Input, Label , Progress} from "reactstrap";
import TranscodeVideo from "./TranscodeVideo";
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { getCurrentUser } from "aws-amplify/auth";
import { uploadData } from "@aws-amplify/storage";
import { profiledata } from '../../slices/thunks';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { VideoLibraryAPI } from '../../helpers/firebase_helper';
const VideoSettingTrans = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state.Profile.profileData);
  const { jobName, workflow, video } = location.state || {};
  const [abortController, setAbortController] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadTask, setUploadTask] = useState(null);
  const current_plan = profileData?.result?.current_plan;
  //  const current_plan = "Basic";
  if (!jobName || !workflow || !video) {
    return <div>Error: Missing required data. Please go back and try again.</div>;
  }
// console.log("VideoSettingTrans loaded with:", { jobName, workflow, video });
  const [tags, setTags] = useState([]);
  const [hlsResolutions, setHlsResolutions] = useState([]);
  const [dashResolutions, setDashResolutions] = useState([]);
  const [hlsAudioDescriptions, setHlsAudioDescriptions] = useState([]);
  const [dashAudioDescriptions, setDashAudioDescriptions] = useState([]);
  const [enableHls, setEnableHls] = useState(true);
  const [enableDash, setEnableDash] = useState(true);
  const [defaultSetting, setDefaultSetting] = useState(true);
  const [thumbnailSettings, setThumbnailSettings] = useState({
    enabled: true,
  });
  const [overlaySettings, setOverlaySettings] = useState({
    offsetTop: '',
    offsetLeft: '',
    width: '',
    height: '',
    opacity: '',
    imageUrl: '',
    enabled: true,
  });

  const [captionsSettings, setCaptionsSettings] = useState({
    enableCaptions: true,
    enableTranslation: true,
    captionFormat: "WebVTT",
    sourceLanguage: "",
    languages: [],
  });

  const [selectedOverlayImage, setSelectedOverlayImage] = useState(null);

  // Language to code mapping
  const languageCodeMap = {
    "Afrikaans": "af",
    "Albanian": "sq",
    "Amharic": "am",
    "Arabic": "ar",
    "Armenian": "hy",
    "Azerbaijani": "az",
    "Bengali": "bn",
    "Bosnian": "bs",
    "Bulgarian": "bg",
    "Catalan": "ca",
    "Chinese (Simplified)": "zh",
    "Chinese (Traditional)": "zh-TW",
    "Croatian": "hr",
    "Czech": "cs",
    "Danish": "da",
    "Dari": "fa-AF",
    "Dutch": "nl",
    "English": "en",
    "Estonian": "et",
    "Farsi (Persian)": "fa",
    "Filipino, Tagalog": "tl",
    "Finnish": "fi",
    "French": "fr",
    "French (Canada)": "fr-CA",
    "Georgian": "ka",
    "German": "de",
    "Greek": "el",
    "Gujarati": "gu",
    "Haitian Creole": "ht",
    "Hausa": "ha",
    "Hebrew": "he",
    "Hindi": "hi",
    "Hungarian": "hu",
    "Icelandic": "is",
    "Indonesian": "id",
    "Irish": "ga",
    "Italian": "it",
    "Japanese": "ja",
    "Kannada": "kn",
    "Kazakh": "kk",
    "Korean": "ko",
    "Latvian": "lv",
    "Lithuanian": "lt",
    "Macedonian": "mk",
    "Malay": "ms",
    "Malayalam": "ml",
    "Maltese": "mt",
    "Marathi": "mr",
    "Mongolian": "mn",
    "Norwegian (Bokmål)": "no",
    "Pashto": "ps",
    "Polish": "pl",
    "Portuguese (Brazil)": "pt",
    "Portuguese (Portugal)": "pt-PT",
    "Punjabi": "pa",
    "Romanian": "ro",
    "Russian": "ru",
    "Serbian": "sr",
    "Sinhala": "si",
    "Slovak": "sk",
    "Slovenian": "sl",
    "Somali": "so",
    "Spanish": "es",
    "Spanish (Mexico)": "es-MX",
    "Swahili": "sw",
    "Swedish": "sv",
    "Tamil": "ta",
    "Telugu": "te",
    "Thai": "th",
    "Turkish": "tr",
    "Ukrainian": "uk",
    "Urdu": "ur",
    "Uzbek": "uz",
    "Vietnamese": "vi",
    "Welsh": "cy"
  };

  const languageOptions = Object.keys(languageCodeMap);

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };


  const handleOverlayImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedOverlayImage(file.name); // Show preview
      // console.log("Selected Overlay Image:", file);

      const user = await getCurrentUser();
      if (!user) {
        toast.error("User not authenticated");
        return;
      }

      const userData = profileData?.result;
      if (!userData) {
        toast.error("Could not retrieve user profile data.");
        return;
      }
      const { storage_used, storage_quota, max_video_size } = userData;
      const remainingStorageBytes = storage_quota - storage_used;
      const fileSizeInBytes = file.size;
      if (fileSizeInBytes > remainingStorageBytes) {
        toast.error(`Not enough storage available. Your remaining storage is ${formatBytes(remainingStorageBytes)}.`);
        return;
      }

      const fileId = uuidv4();
      const originalFileName = file.name;
      const fileExtension = originalFileName.slice(((originalFileName.lastIndexOf(".") - 1) >>> 0) + 2);
      const fileType = file.type;

      const allowedImageTypes = ["image/png", "image/jpeg", "image/webp"];
      if (!allowedImageTypes.includes(fileType)) {
        toast.error("Invalid file format. Please select a PNG, JPEG, or WebP image.");
        return;
      }

      setUploading(true);
      setUploadProgress(0);
      const controller = new AbortController();
      setAbortController(controller);



      try {
        const task = uploadData({
          path: () => `protected/${user.userId}/${fileId}.${fileExtension}`,
          data: file,
          options: {
            contentType: fileType,
            metadata: {
              name: file.name,
            },
            onProgress: ({ transferredBytes, totalBytes }) => {
              if (totalBytes) {
                const percentage = Math.round((transferredBytes / totalBytes) * 100);
                setUploadProgress(percentage);
              }
            }
          },
          signal: controller.signal,
        });
        setUploadTask(task);
        const result = await task.result;
        // console.log("Image upload result:", result);
        
        // Save image to table (like in CreateJobModal)
        const apiData = {
          file_id: fileId,
          s3_key: result.path,
          filename: originalFileName,
          extension: fileExtension,
          content_type: fileType,
          file_type: 'image',
          size_bytes: fileSizeInBytes,
          folder_path: '/',
        };
        
        const apiResponse = await VideoLibraryAPI.createFileFolder(apiData);
        // console.log("Image save API response:", apiResponse);
        
        // Extract the file metadata from API response
        const fileMetadata = apiResponse?.result || apiResponse?.data || apiResponse;
        
        // Get CDN URL from API response (same as CreateJobModal)
        const imageUrl = fileMetadata?.cdn_url || fileMetadata?.file_url || '';
        
        if (!imageUrl) {
          toast.error("Failed to get CDN URL from API response");
          return;
        }
        
        // Store the image URL in overlaySettings
        setOverlaySettings(prev => ({
          ...prev,
          imageUrl: imageUrl
        }));
        
        toast.success("Image uploaded successfully");
        
        dispatch(profiledata(user.userId));
      } catch (err) {
        if (err.name === "AbortError") {
          toast.info("Upload canceled");
        } else {
          toast.error(err);
        }
      } finally {
        setUploading(false);
        setAbortController(null);
      }
    }
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCaptionsSettings((prev) => {
      const updatedSettings = { ...prev, [id]: checked };

      // Disable "Enable Translation" if "Enable Captions" is turned off
      if (id === "enableCaptions" && !checked) {
        updatedSettings.enableTranslation = false;
        updatedSettings.captionFormat = ""; // Clear caption format when captions are disabled
      }

      // Clear targeted languages when translation is disabled
      if (id === "enableTranslation" && !checked) {
        updatedSettings.languages = [];
        // Don't clear sourceLanguage - user can select it regardless of translation toggle
      }

      return updatedSettings;
    });
  };

  const handleRadioChange = (e) => {
    const { value } = e.target;
    setCaptionsSettings((prev) => ({
      ...prev,
      captionFormat: value,
    }));
  };
  const handleAddTag = (e) => {
    if (e.key === "Enter" && e.target.value) {
      const value = e.target.value.trim();
      if (!tags.includes(value)) {
        setTags([...tags, value]);
      }
      if (!captionsSettings.languages.includes(value)) {
        setCaptionsSettings((prev) => ({
          ...prev,
          languages: [...prev.languages, value],
        }));
      }
      e.target.value = "";
      e.preventDefault();
    }
  };

  const handleTargetLanguageChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue && !captionsSettings.languages.includes(selectedValue)) {
      setCaptionsSettings((prev) => ({
        ...prev,
        languages: [...prev.languages, selectedValue],
      }));
      setTags([...tags, selectedValue]);
      e.target.value = ""; // Reset dropdown
    }
  };

  const handleRemoveTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
    setCaptionsSettings((prev) => ({
      ...prev,
      languages: prev.languages.filter((t) => t !== tag),
    }));
  };

  const handleCancel = () => {
    navigate("/video-processor");
  };


  const handleNext = () => {
    // Get video information
    const filename = video?.filename || video?.video_title || "sample.mp4";
    const fileUrl = video?.cdn_url || video?.playback_url || video?.file_url || "";
    const fileId = video?.file_id || "";

    // Validate overlay requirements
    if (overlaySettings.enabled && !overlaySettings.imageUrl) {
      toast.error("Please upload an overlay image");
      return;
    }

    // Convert language names to codes for payload
    const sourceLanguageCode = captionsSettings.sourceLanguage ? languageCodeMap[captionsSettings.sourceLanguage] || captionsSettings.sourceLanguage : "";
    const targetLanguageCodes = captionsSettings.languages.map(lang => languageCodeMap[lang] || lang);

    // Build HLS config array (only when defaultSetting is false)
    const buildHlsConfig = () => {
      if (defaultSetting) return [];
      
      return hlsResolutions.map((res, index) => {
        const audioDesc = hlsAudioDescriptions[index] || {};
        const configItem = {
          Width: parseInt(res.width) || 0,
          Height: parseInt(res.height) || 0,
          Codec: res.codec || "H_264",
          Resolution: res.resolution || "",
          RateControlMode: res.rateControlMode || "QVBR",
          AudioDescriptions: {
            Codec: audioDesc.codec || "AAC",
            Bitrate: parseInt(audioDesc.bitrate) || 0,
            CodingMode: audioDesc.codingMode || "CODING_MODE_2_0",
            SampleRate: parseInt(audioDesc.sampleRate) || 0
          }
        };

        // Add MaxBitrate for QVBR, Bitrate for CBR
        if (res.rateControlMode === "CBR") {
          configItem.Bitrate = parseInt(res.bitrate || res.maxBitrate) || 0;
        } else {
          configItem.MaxBitrate = parseInt(res.maxBitrate || res.bitrate) || 0;
        }

        return configItem;
      });
    };

    // Build DASH config array (only when defaultSetting is false)
    const buildDashConfig = () => {
      if (defaultSetting) return [];
      
      return dashResolutions.map((res, index) => {
        const audioDesc = dashAudioDescriptions[index] || {};
        const configItem = {
          Width: parseInt(res.width) || 0,
          Height: parseInt(res.height) || 0,
          Codec: res.codec || "H_264",
          Resolution: res.resolution || "",
          RateControlMode: res.rateControlMode || "QVBR",
          AudioDescriptions: {
            Codec: audioDesc.codec || "AAC",
            Bitrate: parseInt(audioDesc.bitrate) || 0,
            CodingMode: audioDesc.codingMode || "CODING_MODE_2_0",
            SampleRate: parseInt(audioDesc.sampleRate) || 0
          }
        };

        // Add MaxBitrate for QVBR, Bitrate for CBR
        if (res.rateControlMode === "CBR") {
          configItem.Bitrate = parseInt(res.bitrate || res.maxBitrate) || 0;
        } else {
          configItem.MaxBitrate = parseInt(res.maxBitrate || res.bitrate) || 0;
        }

        return configItem;
      });
    };

    // Build TranscodeVideo configuration
    const transcodeVideoConfig = {
      Enabled: enableHls || enableDash,
      DefaultSettings: defaultSetting,
      CustomSettings: defaultSetting ? {} : {
        Hls: {
          Enabled: enableHls,
          config: buildHlsConfig()
        },
        Dash: {
          Enabled: enableDash,
          config: buildDashConfig()
        }
      }
    };

    // Build Captions configuration
    // Determine SRT and VTT based on selected format
    const captionFormat = captionsSettings.captionFormat || "";
    const isSrtSelected = captionFormat === "SRT" || captionFormat === "WebVTT and  SRT" || captionFormat === "srt";
    const isVttSelected = captionFormat === "WebVTT" || captionFormat === "WebVTT and  SRT" || captionFormat === "webvtt" || captionFormat === "vtt";
    
    const captionsConfig = {
      Enabled: captionsSettings.enableCaptions,
      SrtCaptions: isSrtSelected,
      VttCaptions: isVttSelected,
      TranslateWebCaptions: {
        Enabled: captionsSettings.enableTranslation,
        SourceLanguageCode: sourceLanguageCode || "",
        TargetLanguageCodes: targetLanguageCodes
      }
    };

    // Build ImageOverlay configuration
    const imageOverlayConfig = {
      Enabled: overlaySettings.enabled,
      ImageUrl: overlaySettings.imageUrl || "",
      LeftOffset: parseInt(overlaySettings.offsetLeft) || 0,
      TopOffset: parseInt(overlaySettings.offsetTop) || 0,
      Opacity: parseInt(overlaySettings.opacity) || 50,
      Width: overlaySettings.width ? parseInt(overlaySettings.width) : "",
      Height: overlaySettings.height ? parseInt(overlaySettings.height) : ""
    };

    // Build final payload
    const payload = {
      filename: filename,
      file_url: fileUrl,
      file_id: fileId,
      configuration: {
        Thumbnail: {
          Enabled: thumbnailSettings.enabled
        },
        TranscodeVideo: transcodeVideoConfig,
        Captions: captionsConfig,
        ImageOverlay: imageOverlayConfig
      }
    };

    const summary = {
      jobName,
      workflow,
      video,
      payload: payload
    };
    
    // console.log("Payload:", JSON.stringify(payload, null, 2));
    // console.log("summary", summary);

    navigate("/video-processor/video-setting-trans/summary", { state: summary });
  };
  document.title = "Media Pulse | Video Processor";

  const updateHlsResolutions = useCallback((resolutions) => {
    setHlsResolutions(resolutions);
  }, []);

  const updateDashResolutions = useCallback((resolutions) => {
    setDashResolutions(resolutions);
  }, []);

  const updateHlsAudioDescriptions = useCallback((audioDescriptions) => {
    setHlsAudioDescriptions(audioDescriptions);
  }, []);

  const updateDashAudioDescriptions = useCallback((audioDescriptions) => {
    setDashAudioDescriptions(audioDescriptions);
  }, []);

  const updateEnableHls = useCallback((enabled) => {
    setEnableHls(enabled);
  }, []);

  const updateEnableDash = useCallback((enabled) => {
    setEnableDash(enabled);
  }, []);

  const handleToggleDefaultSetting = () => {
    setDefaultSetting(!defaultSetting);
  };

  return (
    <div className="page-content">
      <Container fluid>
        {/* Breadcrumb */}
        <BreadCrumb title="Video Setting" pageTitle="Video Processor" />

        {/* Cards Section */}
        <div className="row mt-4">
          <div className="row align-items-stretch">
            {/* Job Details Card */}
            <div className="col-md-6 d-flex flex-column">
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Job Details</CardTitle>
                  <hr />
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <CardText>
                      <b>Job Name:</b> {jobName}
                    </CardText>
                    <CardText>
                      <b>Workflow Type:</b> {workflow}
                    </CardText>
                  </div>
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Overlay Image</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-4">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="overlaySwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="overlaySwitch">
                          Overlay Image
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-check form-switch form-check-right mb-4">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="overlaySwitch"
                              checked={overlaySettings.enabled}
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, enabled: e.target.checked })}
                            />
                            <Label className="form-check-label text-muted" htmlFor="overlaySwitch">
                              Overlay Image
                            </Label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="overlayImageUpload"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleOverlayImageChange}
                          />
                          <button
                            type="button"
                            style={{ backgroundColor: "#eff4fd", height: "30px", width: "135px" }}
                            className="btn text-primary"
                            onClick={() => document.getElementById("overlayImageUpload").click()}
                          >
                            {uploading ? 'Uploading...' : 'Upload Image'}
                          </button>
                        </div>
                      </div>
                      {uploading && (
                        <div className="progress-container mt-3">
                          <Progress animated value={uploadProgress} max="100">
                            {uploadProgress}%
                          </Progress>
                        </div>
                      )}
                      {selectedOverlayImage && (
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <p className="text-muted">
                              Selected Image: <b>{selectedOverlayImage}</b>
                            </p>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Offset From Top (pixels)</b></label>
                            <input type="number" className="form-control" placeholder="Enter Offset"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, offsetTop: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Offset From Left (pixels)</b></label>
                            <input type="number" className="form-control" placeholder="Enter Offset"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, offsetLeft: e.target.value })} />

                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label><b>Width</b></label>
                              <input type="number" className="form-control" placeholder="Enter Width"
                                onChange={(e) => setOverlaySettings({ ...overlaySettings, width: e.target.value })} />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label><b>Height</b></label>
                              <input type="number" className="form-control" placeholder="Enter Height"
                                onChange={(e) => setOverlaySettings({ ...overlaySettings, height: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Opacity</b></label>
                            <input type="number" className="form-control" placeholder="Enter Opacity"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, opacity: e.target.value })} />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </div>

            {/* Second Column */}
            <div className="col-md-6 d-flex flex-column">

              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Thumbnail Generation</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-3">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="thumbnailSwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="thumbnailSwitch">
                          Thumbnail Generation
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>
                      <div className="form-check form-switch form-check-right mb-3">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="thumbnailSwitch"
                          checked={thumbnailSettings.enabled}
                          onChange={(e) => setThumbnailSettings({ enabled: e.target.checked })}
                        />
                        <Label className="form-check-label text-muted" htmlFor="thumbnailSwitch">
                          Thumbnail Generation
                        </Label>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>

              {/* Overlay Image Card */}
              


              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Captions</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-4">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="overlaySwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="overlaySwitch">
                          Enable Captions
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-check form-switch form-check-right mb-4">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="enableCaptions"
                              checked={captionsSettings.enableCaptions}
                              onChange={handleCheckboxChange}
                            />
                            <Label className="form-check-label text-muted" htmlFor="overlaySwitch">
                              Enable Captions
                            </Label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-check form-switch form-check-right mb-4">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="enableTranslation"
                              checked={captionsSettings.enableTranslation}
                              onChange={handleCheckboxChange}
                              disabled={!captionsSettings.enableCaptions}
                            />
                            <Label className="form-check-label text-muted" htmlFor="overlaySwitch">
                              Enable Translation
                            </Label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Select Caption Format</b></label>
                            <div className="d-flex align-items-center">
                              <div className="form-check me-3">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="webvttOption"
                                  value="WebVTT"
                                  checked={captionsSettings.captionFormat === "WebVTT"}
                                  onChange={handleRadioChange}
                                  disabled={!captionsSettings.enableCaptions}
                                />
                                <label className="form-check-label" htmlFor="webvttOption">
                                  WebVTT
                                </label>
                              </div>
                              <div className="form-check me-3">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="srtOption"
                                  value="SRT"
                                  checked={captionsSettings.captionFormat === "SRT"}
                                  onChange={handleRadioChange}
                                  disabled={!captionsSettings.enableCaptions}
                                />
                                <label className="form-check-label" htmlFor="srtOption">
                                  SRT
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="bothOption"
                                  value="WebVTT and  SRT"
                                  checked={captionsSettings.captionFormat === "WebVTT and  SRT"}
                                  onChange={handleRadioChange}
                                  disabled={!captionsSettings.enableCaptions}
                                />
                                <label className="form-check-label" htmlFor="bothOption">
                                  Both
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Source Language</b></label>
                            <Input
                              type="select"
                              className="form-control"
                              value={captionsSettings.sourceLanguage}
                              onChange={(e) => setCaptionsSettings({ ...captionsSettings, sourceLanguage: e.target.value })}
                            >
                              <option value="">Select Source Language</option>
                              {languageOptions.map((lang) => (
                                <option key={lang} value={lang}>{lang}</option>
                              ))}
                            </Input>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label><b>Targeted Languages</b></label>
                            <Input
                              type="select"
                              className="form-control"
                              onChange={handleTargetLanguageChange}
                              value=""
                              disabled={!captionsSettings.enableTranslation}
                            >
                              <option value="">Select Targeted Language</option>
                              {languageOptions
                                .filter(lang => !captionsSettings.languages.includes(lang))
                                .map((lang) => (
                                  <option key={lang} value={lang}>{lang}</option>
                                ))}
                            </Input>
                            <div className="tags mt-2">
                              {captionsSettings.languages.map((tag) => (
                                <span className="badge me-2 fs-6" style={{ background: '#50c3e6' }} key={tag}>
                                  {tag}
                                  <button
                                    type="button"
                                    className="btn-close btn-close-white ms-2"
                                    aria-label="Remove"
                                    onClick={() => handleRemoveTag(tag)}
                                    disabled={!captionsSettings.enableTranslation}
                                  ></button>
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </div>
            <div className="col-md-12">
            <Card className="mb-4">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Transcode Video</CardTitle>
                  <div className="form-check form-switch">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      id="defaultSettingToggle"
                      checked={defaultSetting}
                      onChange={handleToggleDefaultSetting}
                    />
                    <Label className="form-check-label text-muted ms-2" htmlFor="defaultSettingToggle">
                      Default Setting
                    </Label>
                  </div>
                </div>
                <hr />
              </CardBody>
              <TranscodeVideo
                onUpdateHlsResolutions={updateHlsResolutions}
                onUpdateDashResolutions={updateDashResolutions}
                onUpdateHlsAudioDescriptions={updateHlsAudioDescriptions}
                onUpdateDashAudioDescriptions={updateDashAudioDescriptions}
                onUpdateEnableHls={updateEnableHls}
                onUpdateEnableDash={updateEnableDash}
                disableResolutionToggles={defaultSetting}
                defaultSetting={defaultSetting}
              />
            </Card>
          </div>
          </div>

          {/* Transcode Video Card - Full Width */}
          

          {/* Save and Cancel Buttons */}
          <div className="d-flex justify-content-end mb-3 me-5">
            <button
              type="button"
              style={{ height: '40px', width: '100px', marginRight: "20px" }}
              className="btn btn-outline-primary"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{ height: '40px', width: '100px', marginRight: "20px" }}
              className="btn btn-success"
              onClick={handleNext}
            >
              Next
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default VideoSettingTrans;
